import { MenuItemProps, useNotificationCount, useTranslationRoute, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuGeneral = () => {

    const [
        GENERAL,
        TRANSLATION,
        NOTIFICATIONS,
        STUDENTS,
        INVOICES
    ] = useTranslations(i18n)
    const translationRoute = useTranslationRoute();
    const notificationCount = useNotificationCount()

    return useMemo((): MenuItemProps => ({
        ke: "general",
        label: GENERAL,
        className: "menu-item-category",
        items: [
            process.env.REACT_APP_ENV === 'development' ? {
                label: TRANSLATION,
                link: translationRoute("admin/translation"),
                startIcon: "fa-solid fa-language",
            } : undefined,
            // {
            //     label: NOTIFICATIONS,
            //     link: translationRoute("admin/notification"),
            //     startIcon: "fa-solid fa-bell",
            //     badge: notificationCount > 0 ? notificationCount : undefined
            // },
            {
                label: STUDENTS,
                link: translationRoute("admin/students"),
                startIcon: "fa-solid fa-school",
                roles: ['STUDENT']
            },
            {
                label: INVOICES,
                link: translationRoute("admin/invoice"),
                startIcon: "fa-solid fa-file-invoice",
                roles: ['INVOICE']
            },
        ],
    }), [notificationCount])
}

const i18n = [
    'BSM.Admin.LeftSideBar.Menu.General.Label',
    'BSM.Admin.LeftSideBar.Menu.General.Translation.Label',
    'Harea.Admin.LeftSideBar.Menu.General.Notifications.Label',
    'BSM.Admin.LeftSideBar.Menu.General.Students.Label',
    'BSM.Admin.LeftSideBar.Menu.General.Invoices.Label',
]
